function partInViewport(elem, offset = {top: 0, bottom: 0}) {
    const y = elem.getBoundingClientRect().top + offset.top;
    const hw = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    const h = elem.clientHeight + offset.bottom;

    return (
        y < hw && y + h > 0
    );
}

function changeClassesFromLI(elements, $nav) {
    const datas = [];

    elements.forEach((e)=> {
        e.element.each((index, section)=>{
            const $section = $(section);
            datas.push({
                top: $section.offset().top,
                height: $section.outerHeight(),
                color: e.color,
            });
        });
    });
    const offsetToViewArray = $nav.find('li').map((index, list) => {
        const targetElement = $('#'+$(list).find('a').attr('href').split('#')[1])[0];
        return targetElement ? window.pageYOffset - targetElement.offsetTop : Infinity;
    });
    const onlyPos = offsetToViewArray.filter((index, number) => number >= 65);
    const smallestPos = Math.min.apply( Math, onlyPos );
    const isActiveArray = offsetToViewArray.map((index, offsetToView) => offsetToView === smallestPos);

    $nav.find('li').each((index, list)=> {
        const $list = $(list);

        // const isActive = partInViewport(document.querySelector($list.find('a').attr('href')), {top: 100, bottom: -200});

        const isActive = isActiveArray[index];

        const backgroundObject = datas.find((data) => {
            return $list.offset().top >= (data.top - ($list.outerHeight() / 2)) && $list.offset().top <= (data.top + data.height - ($list.outerHeight() / 2));
        });
        if (backgroundObject) {
            $list.addClass(backgroundObject.color);
        } else {
            $list.removeClass();
        }
        if (isActive) {
            $list.addClass('active');
        } else {
            $list.removeClass('active');
        }
    });
}

$(() => {
    const $nav = $('nav.side');
    if ($nav.length) {
        const elements = [{
            element: $('section.disturber-yellow'),
            color: 'white',
        }, {
            element: $('section.disturber-grey'),
            color: 'yellow',
        }, {
            element: $('section.disturber-cyan'),
            color: 'white',
        }, {
            element: $('.header-block.bg-color'),
            color: 'white',
        }, {
            element: $('section.contact'),
            color: 'white',
        }, {
            element: $('section.quotation-yellow'),
            color: 'white',
        }, {
            element: $('section.img > .loading').parent(),
            color: 'opacity',
        }, {
            element: $('section.img > .carousel').parent(),
            color: 'opacity',
        }, {
            element: $('footer'),
            color: 'white',
        }];

        changeClassesFromLI(elements, $nav);

        window.addEventListener('scroll', () => {
            changeClassesFromLI(elements, $nav);
        });
        $nav.find('a').on( 'click', (e) => {
            e.preventDefault();
            window.scrollTo({top: $('#'+$(e.target).attr('href').split('#')[1]).offset().top - 50, behavior: 'smooth'});
            // document.querySelector().scrollIntoView({block: 'start', behavior: 'smooth'});
        });
    }
});
